/**
 * Permissions API
 * Routes through APISIX to auth-service: GET /v1/users/me/permissions, the
 * permission set the console reads too (user_handler_permissions.go).
 */

import { apiClient } from './api-client'

interface PermissionSetResponse {
  resources?: {
    missions?: { create?: boolean }
  }
}

export const permissionsApi = {
  /**
   * Whether the signed-in member may create missions: the permission set's
   * resources.missions.create (owner, admin, manager and user; the mission
   * create handler refuses an auditor and a guest).
   */
  async mayCreateMissions(): Promise<boolean> {
    const set = await apiClient.get<PermissionSetResponse>('/v1/users/me/permissions')
    return set?.resources?.missions?.create === true
  },
}
